import { render, staticRenderFns } from "./AddOneProduct.vue?vue&type=template&id=5a0897b4"
import script from "./AddOneProduct.vue?vue&type=script&lang=js"
export * from "./AddOneProduct.vue?vue&type=script&lang=js"
import style0 from "./AddOneProduct.vue?vue&type=style&index=0&id=5a0897b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports